import angular from 'angular';

// given a country code, return the date format for that country code
// e.g. "MM/dd/yyyy"
// parameter: useLongDateFormat (optional)
//     can opt in to use a long formatted version of the date
//     e.g. "d MMMM, y"

const dateFormats = {
    AU: "dd/MM/yyyy",
    NZ: "dd/MM/yyyy",
    US: "MM/dd/yyyy",
    GB: "dd/MM/yyyy",
    CA: "MM/dd/yyyy",
    ES: "dd/MM/yyyy",
    IT: "dd/MM/yyyy",
    FR: "dd/MM/yyyy",
};
const longDateFormats = {
    AU: "d MMMM, y",
    NZ: "d MMMM, y",
    US: "MMMM d, y",
    GB: "d MMMM, y",
    CA: "MMMM d, y",
    ES: "d MMMM, y",
    IT: "d MMMM, y",
    FR: "d MMMM, y",
};

export const countryDateFormat = (countryCode, parameters) =>
    parameters?.useLongDateFormat ? longDateFormats[countryCode]
        : dateFormats[countryCode]
export default countryDateFormat

angular.module("core.application.main")
    .filter("core_application_main_filter_country_date_format", () => countryDateFormat)
